import React from "react";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.National:
      case UserLevel.Province:
        return reportInfo?.selectedKetenagaan === "2" ? (
          <>
            <thead>
              <tr>
                <th>No.</th>
                {currentLevel === UserLevel.National && (
                  <>
                    <th>Provinsi</th>
                  </>
                )}
                <th>Wilayah</th>
                <th>Jum non-puskesmas (RS/Klinik)</th>
                <th>Jum Pelatihan SISMAL</th>
                <th>Jum (RS/Klinik) ada dokter umum</th>
                <th>
                  Jum (RS/Klinik) ada dokter umum yang sudah mendapatkan
                  sosialisasi tatalaksana malaria
                </th>
                <th>
                  Jum (RS/Klinik) Ketersediaan Dokter spesialis penyakit dalam
                </th>
                <th>
                  Jum (RS/Klinik) Ketersediaan Dokter spesialis penyakit dalam
                  yang sudah mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum (RS/Klinik) ada dokter spesialis anak</th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis anak yang sudah
                  mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum (RS/Klinik) ada dokter spesialis kandungan</th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis kandungan yang sudah
                  mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum (RS/Klinik) ada perawat</th>
                <th>
                  Jum (RS/Klinik) ada perawat yang sudah mendapatkan sosialisasi
                  tatalaksana malaria
                </th>
                <th>
                  Jum (RS/Klinik) ada perawat yang sudah mendapatkan sosialisasi
                  skrining malaria pada balita di kab/kota dengan endemis tinggi
                </th>
                <th>Jum (RS/Klinik) ada bidan</th>
                <th>
                  Jum (RS/Klinik) ada bidan yang sudah mendapatkan sosialisasi
                  tatalaksana malaria
                </th>
                <th>
                  Jum (RS/Klinik) ada bidan yang sudah mendapatkan sosialisasi
                  skrining malaria pada kegiatan ANC di Kab/Kota dengan endemis
                  tinggi
                </th>
                <th>
                  Jum puskesmas ketersediaan bidan yang telah mendapatkan
                  sosialisasi skrining malaria pada Balita di Kab/Kota dengan
                  endemis tinggi
                </th>
                <th>Jum (RS/Klinik) ada dokter spesialis patologi klinik</th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis patologi klinik yang
                  sudah mendapatkan sosialisasi QA diagnostik
                </th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis parasitologi klinik
                </th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis parasitologi klinik yang
                  sudah mendapatkan sosialisasi QA diagnostik
                </th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    {currentLevel === UserLevel.National && (
                      <>
                        <td>{item?.nmprop}</td>
                      </>
                    )}
                    <td>{item?.area1}</td>
                    <td>{item?.totalpusk}</td>
                    <td>{item?.plthsismal}</td>
                    <td>{item?.dokterumum}</td>
                    <td>{item?.dokterumum_sosmal}</td>
                    <td>{item?.dok_spd}</td>
                    <td>{item?.dok_spd_sosmal}</td>
                    <td>{item?.dok_anak}</td>
                    <td>{item?.dok_anak_sosmal}</td>
                    <td>{item?.dok_kand}</td>
                    <td>{item?.dokter_kand_sosmal}</td>
                    <td>{item?.perawat}</td>
                    <td>{item?.prwat_sosmal}</td>
                    <td>{item?.prwt_skrining_sosmal_balita}</td>
                    <td>{item?.bidan}</td>
                    <td>{item?.bidan_sosmal}</td>
                    <td>{item?.bidan_sosmal_anc}</td>
                    <td>{item?.bidan_skrining_sosmal_balita}</td>
                    <td>{item?.dok_patologi}</td>
                    <td>{item?.dok_pato_sosmal}</td>
                    <td>{item?.dok_parasitologi}</td>
                    <td>{item?.dok_parasitologi_sosmal}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={currentLevel === UserLevel.National ? 24 : 23}>
                    Tidak Ketersediaan Data
                  </td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td
                  style={{ color: "#FFF" }}
                  colSpan={currentLevel === UserLevel.National ? 3 : 2}
                >
                  Total
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("totalpusk")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("plthsismal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dokterumum")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dokterumum_sosmal")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_spd")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_spd_sosmal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_anak")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_anak_sosmal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_kand")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dokter_kand_sosmal")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("perawat")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("prwat_sosmal")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("prwt_skrining_sosmal_balita")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("bidan")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("bidan_sosmal")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("bidan_sosmal_anc")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("bidan_skrining_sosmal_balita")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_patologi")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_pato_sosmal")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dok_parasitologi")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dok_parasitologi_sosmal")}
                </td>
              </tr>
            </tbody>
          </>
        ) : (
          <>
            <thead>
              <tr>
                <th>No.</th>
                {currentLevel === UserLevel.National && (
                  <>
                    <th>Provinsi</th>
                  </>
                )}

                <th>Wilayah</th>
                <th>Jum puskesmas</th>
                <th>
                  Jum puskesmas dg pengelola mendapatkan pelatihan program
                  manajemen malaria
                </th>
                <th>
                  Jum puskesmas dg pengelola mendapatkan pelatihan reorientasi
                  program malaria
                </th>
                <th>Jum puskesmas dg pengelola mendapatkan pelatihan SISMAL</th>
                <th>
                  Jum puskesmas dg pengelola mendapatkan pelatihan/sosialisasi
                  surveilans malaria
                </th>
                <th>Jum puskesmas ada dokter umum</th>
                <th>
                  Jum puskesmas ada dokter umum yang telah mendapatkan
                  sosialisasi tatalaksana malaria
                </th>
                <th>
                  Jum (RS/Klinik) Ketersediaan Dokter spesialis penyakit dalam
                </th>
                <th>
                  Jum (RS/Klinik) Ketersediaan Dokter spesialis penyakit dalam
                  yang sudah mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum (RS/Klinik) ada dokter spesialis anak</th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis anak yang sudah
                  mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum (RS/Klinik) ada dokter spesialis kandungan</th>
                <th>
                  Jum (RS/Klinik) ada dokter spesialis kandungan yang sudah
                  mendapatkan sosialisasi tatalaksana malaria
                </th>
                <th>Jum puskesmas ketersediaan perawat</th>
                <th>
                  Jum puskesmas ketersediaan perawat yang telah mendapatkan
                  sosialisasi tatalaksana malaria
                </th>
                <th>
                  Jum puskesmas ketersediaan perawat yang telah mendapatkan
                  sosialisasi skrining malaria pada Balita di Kab Endemis Tinggi
                </th>
                <th>Jum puskesmas ketersediaan bidan</th>
                <th>
                  Jum puskesmas ketersediaan bidan yang telah mendapatkan
                  sosialisasi tatalaksana malaria
                </th>
                <th>
                  Jum puskesmas ketersediaan bidan yang telah mendapatkan
                  sosialisasi skrining malaria pada kegiatan ANC di kab endemis
                  tinggi
                </th>
                <th>
                  Jum puskesmas ketersediaan bidan yang telah mendapatkan
                  sosialisasi skrining malaria pada balita di Kab/Kota dengan
                  endemis tinggi
                </th>
                <th>Jum puskesmas yang ada tenaga promkes</th>
                <th>
                  Jum puskesmas yang ada tenaga promkes yang sudah mendapat
                  sosialisasi tentang strategi komunikasi malaria
                </th>
                <th>Jum puskesmas ada entomolog</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    {currentLevel === UserLevel.National && (
                      <>
                        <td>{item?.nmprop}</td>
                      </>
                    )}

                    <td>{item?.area1}</td>
                    <td>{item?.totalpusk}</td>
                    <td>{item?.plthmanajmalaria}</td>
                    <td>{item?.reorientasi}</td>
                    <td>{item?.plthsismal}</td>
                    <td>{item?.plthsurvmal}</td>
                    <td>{item?.dokterumum}</td>
                    <td>{item?.dokterumum_sosmal}</td>
                    <td>{item?.dok_spd}</td>
                    <td>{item?.dok_spd_sosmal}</td>
                    <td>{item?.dok_anak}</td>
                    <td>{item?.dok_anak_sosmal}</td>
                    <td>{item?.dok_kand}</td>
                    <td>{item?.dokter_kand_sosmal}</td>
                    <td>{item?.perawat}</td>
                    <td>{item?.prwat_sosmal}</td>
                    <td>{item?.prwt_skrining_sosmal_balita}</td>
                    <td>{item?.bidan}</td>
                    <td>{item?.bidan_sosmal}</td>
                    <td>{item?.bidan_sosmal_anc}</td>
                    <td>{item?.bidan_skrining_sosmal_balita}</td>
                    <td>{item?.ptgspromkes}</td>
                    <td>{item?.ptgspromkes_sosmal}</td>
                    <td>{item?.entomologmal}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={currentLevel === UserLevel.National ? 25 : 24}>
                    Tidak Ketersediaan Data
                  </td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td
                  style={{ color: "#FFF" }}
                  colSpan={currentLevel === UserLevel.National ? 3 : 2}
                >
                  Total
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("totalpusk")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("plthmanajmalaria")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("reorientasi")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("plthsismal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("plthsurvmal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dokterumum")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dokterumum_sosmal")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_spd")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_spd_sosmal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_anak")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_anak_sosmal")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("dok_kand")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("dokter_kand_sosmal")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("perawat")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("prwat_sosmal")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("prwt_skrining_sosmal_balita")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("bidan")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("bidan_sosmal")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("bidan_sosmal_anc")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("bidan_skrining_sosmal_balita")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("ptgspromkes")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("ptgspromkes_sosmal")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("entomologmal")}</td>
              </tr>
            </tbody>
          </>
        );
      default:
        return reportInfo?.selectedKetenagaan === "2" ? (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Fasyankes</th>
                <th>Nama petugas surveilans/ rekam medik</th>
                <th>Pelatihan SISMAL</th>
                <th>Tahun pelatihan SISMAL terakhir</th>
                <th>Ketersediaan dokter?</th>
                <th>
                  Ketersediaan dokter umum yang sudah mendapatkan sosialisasi
                  tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis penyakit dalam?</th>
                <th>
                  Ketersediaan dokter spesialis penyakit dalam yang sudah
                  mendapatkan sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis anak?</th>
                <th>
                  Ketersediaan dokter spesialis anak yang sudah mendapatkan
                  sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis kandungan?</th>
                <th>
                  Ketersediaan dokter spesialis kandungan yang sudah mendapatkan
                  sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>

                <th>Ketersediaan perawat?</th>
                <th>
                  Ketersediaan perawat yang sudah mendapatkan sosialisasi
                  tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>
                  Ketersediaan perawat yang sudah mendapatkan sosialisasi
                  skrining malaria pada balita di Kab/Kota dengan endemis
                  tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan bidan?</th>
                <th>
                  Juml bidan yang sudah mendapatkan sosialisasi tatalaksana
                  malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>
                  Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining
                  malaria pada kegiatan ANC di Kab/Kota dengan endemis tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>

                <th>
                  Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining
                  malaria pada balita di Kab/Kota dengan endemis tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>

                <th>Ketersediaan dokter spesialis patologi klinik?</th>
                <th>
                  Ketersediaan dokter spesialis patologi klinik yang sudah
                  mendapatkan sosialisasi QA diagnostik?
                </th>
                <th>Tahun sosialisasi terakhir</th>

                <th>Ketersediaan dokter spesialis parasitologi klinik?</th>
                <th>
                  Ketersediaan dokter spesialis parasitologi klinik yang sudah
                  mendapatkan sosialisasi QA diagnostik?
                </th>
                <th>Tahun sosialisasi terakhir</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.namapetugas}</td>
                    <td>{item?.plthsismal}</td>
                    <td>{item?.thnplthsismal}</td>
                    <td>{item?.dokterumum}</td>
                    <td>{item?.dokterumum_sosmal}</td>
                    <td>{item?.thn_dokterumum_sosmal}</td>
                    <td>{item?.dok_spd}</td>
                    <td>{item?.dok_spd_sosmal}</td>
                    <td>{item?.thn_dok_spd_sosmal}</td>
                    <td>{item?.dok_anak}</td>
                    <td>{item?.dok_anak_sosmal}</td>
                    <td>{item?.thn_dok_anak_sosmal}</td>
                    <td>{item?.dok_kand}</td>
                    <td>{item?.dokter_kand_sosmal}</td>
                    <td>{item?.thn_dokter_kand_sosmal}</td>
                    <td>{item?.perawat}</td>
                    <td>{item?.prwat_sosmal}</td>
                    <td>{item?.thn_jmlprwat_sosmal}</td>
                    <td>{item?.prwt_skrining_sosmal_balita}</td>
                    <td>{item?.thn_jmlprwt_skrining_sosmal_balita}</td>
                    <td>{item?.bidan}</td>
                    <td>{item?.bidan_sosmal}</td>
                    <td>{item?.thn_jmlbidan_sosmal}</td>
                    <td>{item?.bidan_sosmal_anc}</td>
                    <td>{item?.thn_jmlbidan_sosmal_anc}</td>
                    <td>{item?.bidan_skrining_sosmal_balita}</td>
                    <td>{item?.thn_bidan_skrining_sosmal_balita}</td>

                    <td>{item?.dok_patologi}</td>
                    <td>{item?.dok_pato_sosmal}</td>
                    <td>{item?.thn_dok_pato_sosmal}</td>

                    <td>{item?.dok_parasitologi}</td>
                    <td>{item?.dok_parasitologi_sosmal}</td>
                    <td>{item?.thn_dok_parasitologi_sosmal}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={34}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        ) : (
          <>
            <thead>
              <tr>
                <th>No</th>
                <th>Fasyankes</th>
                <th>Nama pengelola malaria</th>
                <th>Pelatihan manajemen dasar program malaria bagi tenaga pengelola program malaria</th>
                <th>Tahun pelatihan terakhir</th>
                <th>Pelatihan reorientasi program malaria</th>
                <th>Tahun reorientasi terakhir</th>
                <th>Pelatihan SISMAL</th>
                <th>Tahun pelatihan SISMAL terakhir</th>
                <th>Pelatihan/ sosialisasi surveilans malaria</th>
                <th>Tahun pelatihan terakhir</th>
                <th>Ketersediaan dokter umum?</th>
                <th>
                  Ketersediaan dokter umum yang tersosialisasi tatalaksana
                  malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis penyakit dalam?</th>
                <th>
                  Ketersediaan dokter spesialis penyakit dalam yang sudah
                  mendapatkan sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis anak?</th>
                <th>
                  Ketersediaan dokter spesialis anak yang sudah mendapatkan
                  sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan dokter spesialis kandungan?</th>
                <th>
                  Ketersediaan dokter spesialis kandungan yang sudah mendapatkan
                  sosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan perawat?</th>
                <th>
                  Ketersediaan perawat yang tersosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>
                  Ketersediaan perawat yang tersosialisasi skrining malaria pada
                  balita di Kab/Kota dengan endemis tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan bidan?</th>
                <th>
                  Ketersediaan bidan yang tersosialisasi tatalaksana malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>
                  Ketersediaan bidan yang tersosialisasi skrining malaria pada
                  kegiatan ANC di Kab/Kota dengan endemis tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>
                  Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining
                  malaria pada balita di Kab/Kota dengan endemis tinggi?
                </th>
                <th>Tahun sosialisasi terakhir</th>

                <th>Ketersediaan tenaga promkes?</th>
                <th>
                  Ketersediaan tenaga promkes yang tersosialisasi tentang
                  komunikasi malaria?
                </th>
                <th>Tahun sosialisasi terakhir</th>
                <th>Ketersediaan tenaga terlatih entomologi malaria?</th>
                <th>Tahun pelatihan terakhir</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.namapetugas}</td>
                    <td>{item?.plthmanajmalaria}</td>
                    <td>{item?.thnplthmanajmalaria}</td>
                    <td>{item?.reorientasi}</td>
                    <td>{item?.thnreorientasi}</td>
                    <td>{item?.plthsismal}</td>
                    <td>{item?.thnplthsismal}</td>
                    <td>{item?.plthsurvmal}</td>
                    <td>{item?.thnplthsurvmal}</td>
                    <td>{item?.dokterumum}</td>
                    <td>{item?.dokterumum_sosmal}</td>
                    <td>{item?.thn_dokterumum_sosmal}</td>
                    <td>{item?.dok_spd}</td>
                    <td>{item?.dok_spd_sosmal}</td>
                    <td>{item?.thn_dok_spd_sosmal}</td>
                    <td>{item?.dok_anak}</td>
                    <td>{item?.dok_anak_sosmal}</td>
                    <td>{item?.thn_dok_anak_sosmal}</td>
                    <td>{item?.dok_kand}</td>
                    <td>{item?.dokter_kand_sosmal}</td>
                    <td>{item?.thn_dokter_kand_sosmal}</td>
                    <td>{item?.perawat}</td>
                    <td>{item?.prwat_sosmal}</td>
                    <td>{item?.thn_jmlprwat_sosmal}</td>
                    <td>{item?.prwt_skrining_sosmal_balita}</td>
                    <td>{item?.thn_jmlprwt_skrining_sosmal_balita}</td>
                    <td>{item?.bidan}</td>
                    <td>{item?.bidan_sosmal}</td>
                    <td>{item?.thn_jmlbidan_sosmal}</td>
                    <td>{item?.bidan_sosmal_anc}</td>
                    <td>{item?.thn_jmlbidan_sosmal_anc}</td>
                    <td>{item?.bidan_skrining_sosmal_balita}</td>
                    <td>{item?.thn_bidan_skrining_sosmal_balita}</td>

                    <td>{item?.ptgspromkes}</td>
                    <td>{item?.ptgspromkes_sosmal}</td>
                    <td>{item?.thn_ptgspromkes_sosmal}</td>
                    <td>{item?.entomologmal}</td>
                    <td>{item?.thn_plth_entomologmal}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={39}>Tidak Ketersediaan Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v4, Laporan Ketenagaan Puskesmas</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            :{" "}
            {reportInfo?.selectedKetenagaan === "1"
              ? "Semua Puskesmas"
              : "Semua Non-Puskesmas (RS,Klinik,dll)"}
          </th>
        </tr>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
